import { render, staticRenderFns } from "./submissions.participants.page.vue?vue&type=template&id=336cbb69&"
import script from "./submissions.participants.page.vue?vue&type=script&lang=js&"
export * from "./submissions.participants.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports